<div class="container-fluid">
    <div class="row">
        <div class="col-12">
            <div class="container-fluid">
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                      <li class="breadcrumb-item"><a>Client</a></li>
                      <li class="breadcrumb-item active" aria-current="page">Team</li>
                    </ol>
                </nav>
                <div class="row">
                    <div class="col-12">
                        <div class="card">
                            <form [formGroup]="TeamForm" style="margin: 10px;">
                                <div class="form-row">

                                    <div class="form-group col-md-4">
                                        <label for="">Team Name</label>
                                        <input type="text" class="form-control" formControlName="teamname">
                                    </div>

                                    <div class="form-group col-md-4" >
                                        <label for="">Status</label>
                                        <select formControlName="status" class="form-control">
                                            <option value="">Choose</option>
                                            <option value="true">Active</option>
                                            <option value="false">In active</option>
                                        </select>
                                    </div>

                                </div>
                                <div class="d-flex justify-content-end">
                                    <button class="btn btn-sm btn-success mr-1" (click)="addteam()" *ngIf="addmode">ADD</button>
                                    <button class="btn btn-sm btn-dark mr-1" (click)="editteam()" *ngIf="addmode">EDIT</button>
                                    <button class="btn btn-sm btn-info mr-1" (click)="updateteam()" *ngIf="editmode">UPDATE</button>
                                    <button class="btn btn-sm btn-primary mr-1" (click)="cancel()" *ngIf="editmode">Cancel</button>
                                    <button class="btn btn-sm btn-danger mr-1" (click)="deleteteam()">DELETE</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <ag-grid-angular #agGrid 
                            style="width: auto; height: 300px;"
                            class="ag-theme-alpine"
                            [rowData]="TeamList"
                            [rowSelection]="'multiple'"
                            [columnDefs]="TeamcolumnDefs"
                            [pagination]="true">
                        </ag-grid-angular>
                    </div>
                </div>
            </div>
            
        </div>
    </div>
</div>
<!-- 
<div class="container-fluid">
    <div class="row" style="text-align:left">
        <div class="col-2">
            <div class="card" style="padding: 20px; height:350px;overflow-y: scroll;">
                <ul style="list-style: none;">
                    <li *ngFor="let item of teamdataList" style="margin: 10px;"><a (click)="getteamdata(item._id)">{{item._id}}</a></li>
                </ul>
            </div>
        </div>
        <div class="col-10" >
            <div class="d-flex" style="justify-content: center;">
                <div *ngFor="let item of teamdataList | filterBy:userFilter">
                    <div class="tree">
                        <ul>
                            <li>
                                <a href="#">{{item._id}}</a>
                                <ul>
                                    <li *ngFor="let item of item.data">
                                        <a >{{item.member_designation_id}} 
                                            <span *ngIf="item.delete_status == 'TRUE'" style="color: red; font-size: 10px;">Inactive</span>
                                            <span *ngIf="item.delete_status == 'FALSE'" style="color: green; font-size: 10px;">Active</span>
                                        </a>
                                  
                                    </li>
                                </ul>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div> -->

<div class="container-fluid">

    <div class="row">
        <div class="col-12">
            <div class="container-fluid">
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                      <li class="breadcrumb-item"><a>Client</a></li>
                      <li class="breadcrumb-item active" aria-current="page">Members</li>
                    </ol>
                </nav>
                <div class="row">
                    <div class="col-12">
                        <div class="card">
                            <form [formGroup]="TeammembersForm" style="margin: 10px;">
                                <div class="form-row">
                                    <div class="form-group col-md-6">
                                        <label for="">Select Team</label>
                                        <select class="form-control" formControlName="team_name">
                                            <option value="">Choose</option>
                                            <option *ngFor="let item of TeamList" [value]="item.teamname">{{item.teamname}}</option>
                                        </select>
                                    </div>
                                    <div class="form-group col-md-6">
                                        <label for="">Select Designation</label>
                                        <select class="form-control" formControlName="member_designation_id" (change)="getbydesc($event)">
                                            <option value="">Choose</option>
                                            <option *ngFor="let item of Designation" [value]="item.designation_type">{{item.designation_type}}</option>
                                        </select>
                                    </div>
                                           
                                    <div class="form-group col-md-6">
                                        <label for="">Select Member</label>
                                        <ng-multiselect-dropdown
  [placeholder]="'Select Person'"
  [settings]="dropdownSettings"
  [data]="memberList"
  [(ngModel)]="selectedItems"
  (onSelect)="onItemSelect($event)"
  (onSelectAll)="onSelectAll($event)"
  formControlName="member_user_id"
>
</ng-multiselect-dropdown>
                                        <!-- <select class="form-control" formControlName="member_user_id">
                                            <option value="">Choose</option>
                                            <option *ngFor="let item of memberList" [value]="item._id">{{item.name}}</option>
                                        </select> -->
                                    </div>

                                    <div class="form-group col-md-6">
                                        <label for="">Select Report To Designation</label>
                                        <select class="form-control" (change)="getreporttodesc($event)">
                                            <option value="">Choose</option>
                                            <option *ngFor="let item of Designation" [value]="item.designation_type">{{item.designation_type}}</option>
                                        </select>
                                    </div>

                                    <div class="form-group col-md-6">
                                        <label for="">Select Report To Member</label>
                                        <select class="form-control" formControlName="member_reporting_to_id" >
                                            <option value="">Choose</option>
                                            <option *ngFor="let item of RPmemberList" [value]="item._id">{{item.name}}</option>
                                        </select>
                                    </div>

                                    <div class="form-group col-md-6" >
                                        <label for="">Status</label>
                                        <select formControlName="delete_status" class="form-control">
                                            <option value="">Choose</option>
                                            <option value="true">Active</option>
                                            <option value="false">In active</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="d-flex justify-content-end">
                                    <button class="btn btn-sm btn-success mr-1" (click)="addteammembers()" *ngIf="addmode">ADD</button>
                                    <button class="btn btn-sm btn-dark mr-1" (click)="editteammembers()" *ngIf="addmode">EDIT</button>
                                    <button class="btn btn-sm btn-info mr-1" (click)="updateteammembers()" *ngIf="editmode">UPDATE</button>
                                    <button class="btn btn-sm btn-primary mr-1" (click)="cancelteammembers()" *ngIf="editmode">Cancel</button>
                                    <button class="btn btn-sm btn-danger mr-1" (click)="deleteteammembers()">DELETE</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <ag-grid-angular #agGrid2 
                            style="width: auto; height: 500px;"
                            class="ag-theme-alpine"
                            [rowData]="TeamMembersList"
                            [rowSelection]="'multiple'"
                            [columnDefs]="TeammemberscolumnDefs"
                            [pagination]="true">
                        </ag-grid-angular>
                    </div>
                </div>
            </div>
            
        </div>
    </div>
</div>